import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom'
import { URL } from "../config"
// import "./styles_components/UserTransaction.css"

const UserTransaction = () => {
    let {userId} = useParams()
    const [transactions, setTransactions] = useState([])
    // console.log(transactions)

    useEffect(() => {
        fetch(`${URL}/transactions/${userId}`, {
            headers: {
                "x-auth-token": localStorage.getItem('token')
            }
        })
            .then(res => res.json())
        .then(data => setTransactions(data))
    })

   
    return (
        <div className="userTransaction-background">
            <h3 className="text-center py-5">My Transactions</h3> 
        <div className="container">
            {
                transactions.length ? 
            <table className="table table-hover">
                <thead>
                        <tr>
                            <th>Transaction ID</th>
                            <th>Tour</th>
                            <th>Days</th>
                            <th>Person</th>                           
                            <th>Amount</th>
                            <th>Payment</th>
                            <th>Status</th>
                            <th>Date</th>
                        </tr>   
                </thead>
                        <tbody>
                            { transactions.map(transaction => (
                                <tr key={transaction._id}>
                                    <td>{transaction._id}</td>
                                    <td className="line-break">
                                        {
                                            transaction.products.map(product => (product.name))
                                        }
                                    </td>

                                    <td>
                                        {
                                            transaction.products.map(product => (product.days))
                                        }
                                    </td>

                                    <td>
                                        {
                                            transaction.products.map(product => (product.quantity))
                                        }
                                    </td>

                                    <td>PHP {transaction.total}</td>

                                    <td>{transaction.paymentMode}</td>
                                   
                                    <td>
                                        {   transaction.statusId === "5e9e4589ccb840ad756452be" ?
                                            "Pending" : (transaction.statusId === "5e9e45e2ccb840ad756452d9" ?
                                            "Reserved" : "Cancelled"
                                            )
                                        }
                                    </td>
                                    
                                    <td>{new Date(transaction.dateCreated).toLocaleString()}</td>
                                </tr>
                                    ))}
                        </tbody>
            </table>
            
            :<h4 className="text-center"> No transactions to show. </h4>}
        </div>
        </div>
    )
}

export default UserTransaction;